// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".styles-module__message__DIfPp{padding:10px 0;background:#064785;color:#fff;font-size:15px;position:relative;border-bottom:1px solid lightgrey}.styles-module__message__DIfPp a{color:white;text-decoration:underline}.styles-module__message__DIfPp a:hover{color:lightgrey}.styles-module__message__DIfPp .styles-module__messageContainer__oofqp{display:flex;justify-content:space-between;align-items:center}.styles-module__message__DIfPp i.styles-module__close__38FEU{cursor:pointer}\n", ""]);
// Exports
exports.locals = {
	"message": "styles-module__message__DIfPp",
	"messageContainer": "styles-module__messageContainer__oofqp",
	"close": "styles-module__close__38FEU"
};
module.exports = exports;
